import ErrorHandler from '@/ErrorHandler';
import GlobalEventBus from '@/GlobalEventBus';
import GlobalEvents from '@/GlobalEvents';
import API from '@/org-app/api';
import i18n from '@/vueI18n';

const actions = {
  getReportSummaries({ commit }, { params, shouldWarnUserOnError = true }) {
    return new Promise((resolve, reject) => {
      if (params.showLoader) {
        GlobalEventBus.$emit(GlobalEvents.loading);
      }
      API.instance.postReportSummaries(
        params,
        (stats) => {
          resolve(stats);
          if (params.showLoader) {
            GlobalEventBus.$emit(GlobalEvents.loaded);
          }
        },
        (error) => {
          if (shouldWarnUserOnError) {
            const msg = i18n.global.t('messages.failedToGetReportSummaries');
            ErrorHandler.showError(msg, error);
          }
          reject(error);
          if (params.showLoader) {
            GlobalEventBus.$emit(GlobalEvents.loaded);
          }
        },
      );
    });
  },

  getReportSummaryGroupings({ commit }, { params, shouldWarnUserOnError = true }) {
    return new Promise((resolve, reject) => {
      // GlobalEventBus.$emit(GlobalEvents.loading);
      API.instance.postReportSummaryGroupings(
        params,
        (stats) => {
          resolve(stats);
          // GlobalEventBus.$emit(GlobalEvents.loaded);
        },
        (error) => {
          if (shouldWarnUserOnError) {
            const msg = i18n.global.t('messages.failedToGetReportSummaries');
            ErrorHandler.showError(msg, error);
          }
          reject(error);
          // GlobalEventBus.$emit(GlobalEvents.loaded);
        },
      );
    });
  },

  getReportSummaryActiveFilters(
    { commit },
    { fromDate, toDate, includeChildOrgs = false, cancelTokenSource, shouldWarnUserOnError = true },
  ) {
    return new Promise((resolve, reject) => {
      API.instance.getReportSummaryActiveFilters(
        { fromDate, toDate, includeChildOrgs, cancelTokenSource },
        (stats) => {
          resolve(stats);
        },
        (error) => {
          if (shouldWarnUserOnError) {
            const msg = i18n.global.t('messages.failedToGetReportSummaryActiveFilters');
            ErrorHandler.showError(msg, error);
          }
          reject(error);
        },
      );
    });
  },
};

export default actions;
